<template>
  <div class="h-100">
    <div v-if="showStep===steps.DEFAULT" class="h-100">
      <div class="match-card match-card__question">
        <div>
          <div class="question-card__mark-left title title--large title--white">?</div>
          <div class="question-card__mark-right title title--large title--white">?</div>
        </div>

        <div class="avatar-single avatar-single--circle avatar-single--border-one" :style="{'background-image':'url(' + current.profile.avatar_url + ')'}"></div>

        <div class="question-card__desc ">
          <div class="title title--large title--white d-none">
            {{ responseMessage }} <br>
          </div>

          <div class="title title--large title--white">
            {{ current.profile.quiz.question }}
          </div>

          <div class="desc desc--white mt-1 mb-2" v-html="trans.get('pages:match_game.match_card.ask_question_properly', {profileName: current.profile.name, userName: user.name})">
          </div>
        </div>

        <div class="question-card__questions">
          <button
            class="button button__fill button__fill--transparent question-card__answer-button"
            :class="{'button-disabled':wrongAnswers.includes(answers.id),'button-available':!wrongAnswers.includes(answers.id)}"
            v-for="answers in current.profile.quiz.answers"
            v-on:click="sendAnswer(answers.id)"
            :disabled="wrongAnswers.includes(answers.id)"
          >
            <div class="question-card__answer-button-content">
              {{ answers.name }} <i class="demo-icon icon-arrow-circle"></i>
            </div>
          </button>
        </div>

        <div class="question-card__button">
          <button v-on:click="emitCancel()" class="button button__link--underline button__link--white">{{ trans.get('pages:match_game.wrong_answer_card.cancel_button') }}</button>
        </div>
      </div>
    </div>

    <div v-else-if="showStep===steps.GOOD_ANSWER" class="h-100">
      <div class="match-card match-card__match text-center">
        <div class="match-card__desc">
          <div class="title title--big title--white title--font-secondary">
            {{ responseMessage || trans.get('pages:match_game.api.match') }}
          </div>
          <div class="desc desc--white mt-1">
            {{ trans.get('pages:match_game.match_card.header') }}
          </div>
        </div>

        <div class="avatar-with-avatar">
          <div class="avatar-with-avatar__first heartbeat" :style="{'background-image':'url(' + user.web_avatar_url + ')'}"></div>
          <div class="avatar-with-avatar__second heartbeat" :style="{'background-image':'url(' + current.profile.avatar_url + ')'}"></div>
        </div>

        <div class="match-card__info">
          <div class="desc desc--white">
            {{ trans.get('pages:match_game.match_card.you_and') }} <strong>{{ current.profile.name }}</strong> {{ trans.get('pages:match_game.match_card.have_similar_minds') }}
          </div>
        </div>

        <div class="match-card__form">
          <div class="d-flex align-items-center">
            <div class="flex-grow-1 pr-2">
              <input v-model="message" type="text" class="input-text input-text__fill input-text__fill--white" minlength="3">
            </div>
            <button v-on:click="sendMessage()" class="button button__outline button__outline--white-hov-purple">{{ trans.get('pages:match_game.match_card.send_button') }}</button>
          </div>
        </div>

        <div class="mmatch-card__button">
          <button v-on:click="emitNext()" class="button button__link--underline button__link--white">{{ trans.get('pages:match_game.match_card.keep_looking_button') }}</button>
        </div>
      </div>
    </div>
    <div v-else-if="showStep===steps.WRONG_ANSWER" class="h-100">
      <div class="match-card match-card__wrong-answer text-center">
        <div class="match-card__desc">
          <div class="title title--large title--white">
            {{ responseMessage || trans.get('pages:match_game.api.wrong_answer') }}
          </div>
          <div class="desc desc--white mt-1">
            {{ trans.get('pages:match_game.wrong_answer_card.header') }}
          </div>
        </div>

        <div class="match-card__image">
          <div class="avatar-single avatar-single--circle avatar-single--border-one" :style="{'background-image':'url(' + current.profile.avatar_url + ')'}">
          </div>
        </div>

        <div class="match-card__button">
          <button v-on:click="pay()" class="button button__fill button__fill--gradient-orange"><i class="demo-icon icon-time-left pr-1"></i> {{ trans.get('pages:match_game.wrong_answer_card.try_once_more') }}
          </button>

          <div class="desc desc--white mt-2">
            {{ tryAgainValue }} {{ trans.get('pages:match_game.wrong_answer_card.coins') }}
          </div>
        </div>

        <div class="match-card__button-second">
          <button v-on:click="emitSkip()" class="button button__link--underline button__link--white">{{ trans.get('pages:match_game.wrong_answer_card.keep_looking_button') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'LoveCard',
  props: {
    value: Object,
    current: Object,
    step: {
      default: 'DEFAULT',
    }
  },
  data() {
    return {
      canCancel: true,
      showStep: 'DEFAULT',
      steps: {
        DEFAULT: 'DEFAULT',
        GOOD_ANSWER: 'GOOD_ANSWER',
        WRONG_ANSWER: 'WRONG_ANSWER',
      },
      responseMessage: null,
      answer: null,
      //  wrongAnswers: [],
      message: null,
      tryAgainValue: null,
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
    ...mapGetters('matchGame', {
      wrongAnswers: 'getWrongAnswers',
    }),
  },
  methods: {
    emitNext() {
      this.$emit('input', { visible: false, });
      this.$emit('next', 'NEXT');
    },
    emitSkip() {
      this.$emit('input', { visible: false, });
      this.$emit('skip', 'SKIP');
    },
    emitCancel() {
      this.$emit('input', { visible: false, });
    },
    sendAnswer(answerId) {
      this.answer = answerId;
      return axios.post(zRoute('ajax.match_game.love', this.current.profile.id), {
        answer_id: answerId,
        question_id: this.current.profile.quiz.id,
      }).then(response => {
        if (response.data.status === 'success') {
          this.showStep = this.steps.GOOD_ANSWER;
          this.$store.dispatch('profiles/loadMatches');
        }

        this.responseMessage = response.data.message;
      }).catch(error => {
        this.errorResponseHandling(error.response.data, answerId);
      });
    },
    pay() {
      this.$store.dispatch('matchGame/addWrongAnswer', this.answer);

      return axios.post(zRoute('ajax.match_game.love_try_again', this.current.profile.id), {})
        .then(response => {
          if (response.data.status === 'success') {
            this.showStep = this.steps.DEFAULT;
          }
          this.responseMessage = response.data.message;
        }).catch(error => {
          this.errorResponseHandling(error.response.data);
        });
    },
    errorResponseHandling(data, answerId = null) {
      if (data.status === 'error') {
        if (data.reason === this.globals.actions.ACTION_WRONG_ANSWER_NEXT) {
          this.emitNext();
          return;
        }

        if (data.reason === this.globals.actions.ACTION_WRONG_ANSWER) {
          this.showStep = this.steps.WRONG_ANSWER;
          this.$store.dispatch('matchGame/addWrongAnswer', answerId);
        }
      }
      this.responseMessage = data.message;
    },
    sendMessage() {
      return axios.post(zRoute('ajax.match_game.love_message', this.current.profile.id), {
        message: this.message,
      }).then(response => {
        if (response.data.status === 'success') {
          this.showStep = this.steps.MESSAGE;
          this.emitNext();
        }
        this.responseMessage = response.data.message;
      }).catch(error => {
        this.errorResponseHandling(error.response.data);
      });
    },
  },
  mounted() {
    this.showStep = this.step;
    this.tryAgainValue = window.globals.settings_payment_answer_try_again;

  }
};
</script>


